<ng-container *ngIf="ViewStyleConfig$ | async as conf; else loadingTemplate">
    <app-detail-view-template [ShowButtons]="ShownButtons">
        <ng-container *appDetailViewTopContent>
            <ng-container *ngIf="!(bs.MobileQuery | async)">
                <app-pseudo-stepper *ngIf="statusBackofficeSteps$ | async as steps" [activeStep]="steps.active" [steps]="steps.steps"> </app-pseudo-stepper>
            </ng-container>
        </ng-container>
        <ng-container *appDetailViewButtons>
            <app-detail-list-template *ngIf="ShowStatus" class="dark-theme" [Inline]="true" [Editing]="true" [Data]="StatusData | async" style="margin: 0.5rem; min-width: 6rem"> </app-detail-list-template>

            <button *ngFor="let f of missingSharepointFolders$ | async" Inverted class="header-button" app-round-button [matTooltip]="f.tooltip" (click)="addMissingSharepointFolder(f.customFunctionSlug)" [IsLoading]="LS.IsLoading$ | async">
                <app-double-icon [Icon2]="'plus'" [Icon]="'folder'"></app-double-icon>
            </button>

            <ng-container *ngIf="(canBillCommission$ | async) as hasPermission">
                <ng-container *ngIf="!(Editing$ | async) as editing">
                    <button *ngIf="hasPermission && editing" [matMenuTriggerFor]="documentTypeMenu" app-round-button class="header-button" Inverted [matTooltip]="(cls.getSingle$('Commission') | async) + ' abrechnen'" matTooltipPosition="left">
                <app-double-icon [Icon]="ReportsPageMeta.Icon" Icon2="plus"></app-double-icon>
            </button>
                </ng-container>
            </ng-container>
            <mat-menu #documentTypeMenu="matMenu" class="wide-menu">
                <button
                    (click)="$event.stopPropagation()"
                    class="create-arls-from-commission-info"
                    mat-menu-item
                    [matTooltip]="
                        'Diese Funktion sammelt alle bis zum jetzigen Zeitpunkt neuen Zeiten, Materialien und im Bautagebuch eingegeben Informationen zusammen und macht einen Rechnungsvorschlag. Sollten Informationen fehlen, kann es an einem fehlenden Bautagebucheintrag liegen, wodurch auch die Fahrtzone ignoriert werden könnte.'
                    "
                >
                    <fa-icon icon="info-circle" size="lg"></fa-icon>
                </button>
                <button mat-menu-item (click)="NewReport(false); $event.stopPropagation()">Es sollen die <strong>verbrauchten</strong> Materialien in die Rechnung einfließen.
                    <fa-icon [matTooltip]="'Unter Material werden verbrauchte Materialien (Ist-Wert) angezeigt. Diese können manuell angelegt, mit versandten oder gebuchten mit Lieferscheinen automatisch erzeugt werden.'"
                             data-html=true icon="info-circle" size="lg"></fa-icon>
                </button>
                <button mat-menu-item (click)="NewReport(true); $event.stopPropagation()">Es sollen die <strong>gebuchten</strong> Materialien in die Rechnung einfließen.
                    <fa-icon [matTooltip]="'Unter Material werden gebuchte Materialien (Soll-Wert) angezeigt. Diese werden durch versandte oder gebuchte Bestellungen automatisch erzeugt.'" icon="info-circle" size="lg"></fa-icon>
                </button>
                <button mat-menu-item (click)="NewReport(false, false); $event.stopPropagation()">Es sollen die <strong>keine</strong> Materialien in die Rechnung einfließen.
                </button>
                <!-- SchlussRechnung, Abschlagsrechnung -->
            </mat-menu>

            <button
                *ngIf="!(Editing$ | async) && (canEditStatusFromBackoffice$ | async)"
                app-round-button
                class="header-button"
                Inverted
                (click)="ShowStatus = !ShowStatus"
                aria-label="Status ändern"
                matTooltip="Status ändern"
                [IsLoading]="LS.IsLoading$ | async"
                [Disabled]="DisableStatusButton$ | async"
            >
                <fa-icon [icon]="ShowStatus ? 'chevron-right' : 'info'"></fa-icon>
            </button>
            <button
                *ngIf="!(Editing$ | async)"
                app-round-button
                Inverted
                class="header-button"
                matTooltip="Bearbeiten"
                aria-label="Bearbeiten"
                [Disabled]="(Commission$ | async)?.Deleted || !(canEditCommission$ | async)"
                (click)="Editing$.next(true)"
            >
                <fa-icon icon="pencil-alt"></fa-icon>
            </button>
            <button *ngIf="Editing$ | async" app-round-button Color="green" class="header-button" aria-label="Speichern" matTooltip="Speichern" [Disabled]="AreFormsInvalid" (click)="Save$.next(undefined)">
                <fa-icon icon="save"></fa-icon>
            </button>

            <button app-round-button *ngIf="(HasDiary$ | async) && !(Editing$ | async) && (canGetConstructionDiary$ | async)" Inverted class="header-button" (click)="OpenSelectDiaryDate()" aria-label="Bautagebuch hinzufügen" matTooltip="Bautagebuch hinzufügen">
                <fa-icon [icon]="ConstructionDiaryIcon"></fa-icon>
            </button>
            <button app-round-button Inverted class="header-button" *ngIf="!(Editing$ | async) && (canSeeHourList$ | async)" aria-label="Stundenliste" matTooltip="Stundenliste" (click)="OpenTimeTracker()">
                <fa-icon icon="stopwatch"></fa-icon>
            </button>
            <button app-round-button Inverted *ngIf="!(Editing$ | async)" class="header-button" aria-label="E-Mail senden" matTooltip="E-Mail senden" [Disabled]="DisableMailButton$ | async" (click)="OpenMailDialog()">
                <fa-icon icon="paper-plane"></fa-icon>
            </button>
            <button app-round-button Inverted class="header-button" *ngIf="!(Editing$ | async) && (canUseQuickAddButton$ | async)" aria-label="Schnell anlegen" matTooltip="Schnell Hinzufügen" [matMenuTriggerFor]="QuickMenu" [Disabled]="DisableAddEventButton$ | async">
                <div class="icon-mutiple">
                    <fa-icon icon="history" size="xs"></fa-icon>
                    <fa-icon icon="plus" size="xs"></fa-icon>
                </div>
            </button>
            <mat-menu #QuickMenu="matMenu">
                <button mat-menu-item (click)="CreateEventAndTransmission()">
                    <div class="menu-icon-wrapper">
                        <span>Event mit Videoübetragung</span>
                        <fa-icon icon="video"></fa-icon>
                    </div>
                </button>
                <button mat-menu-item (click)="CreateCall()">
                    <div class="menu-icon-wrapper">
                        <span>Telefonat</span>
                        <fa-icon icon="phone"></fa-icon>
                    </div>
                </button>
                <button mat-menu-item (click)="CreateOnSiteEvent()">
                    <div class="menu-icon-wrapper">
                        <span>Ortstermin</span>
                        <fa-icon icon="map-marker-alt"></fa-icon>
                    </div>
                </button>
                <button mat-menu-item (click)="CreateEvent()">
                    <div class="menu-icon-wrapper">
                        <span>Ereignis</span>
                        <fa-icon icon="history"></fa-icon>
                    </div>
                </button>
                <div *ngIf="PS.Has$(PS.Permissions.CreateEvents) | async">
                    <button mat-menu-item (click)="CreateTask()">
                        <div class="menu-icon-wrapper">
                            <span>Aufgabe</span>
                            <fa-icon icon="clipboard-check"></fa-icon>
                        </div>
                    </button>
                </div>
            </mat-menu>

            <button *ngIf="Editing$ | async" app-round-button Inverted class="header-button" aria-label="Zurücksetzen" matTooltip="Zurücksetzen" (click)="Editing$.next(false)">
                <fa-icon icon="undo"></fa-icon>
            </button>

            <button
                app-round-button
                *ngIf="Editing$ | async"
                class="header-button"
                Color="red"
                aria-label="Löschen"
                matTooltip="Löschen"
                [Disabled]="(Commission$ | async)?.Deleted || !(canDeleteCommission$ | async)"
                (click)="DeleteCommission()"
            >
                <fa-icon icon="trash"></fa-icon>
            </button>
        </ng-container>
        <ng-container *appDetailViewLeftContent>
            <div class="detail-card" style="max-width: 100vw" *ngIf="Commission$ | async as data">
                <!--oberster container in der standardansicht-->
                <mat-card *ngIf="(showWizard$ | async) && (CommissionMainData | async) && (CommissionSubData | async)" style="margin-top: 1rem">
                    <mat-card-header>
                        <h2>{{ wizardComponent?.Headline$ | async }}</h2>
                    </mat-card-header>
                    <app-commission-wizard
                        #wizardComponent
                        [CommissionId]="data.Id"
                        [DetailListTemplateEntrys]="DetailListTemplateEntrys"
                        (Save)="Save$.next($event)"
                        [StatusBackofficeForm]="this.CommissionForm.controls.StatusBackofficeId"
                        [PartnerOfficeForm]="this.CommissionForm.controls.PartnerOffice"
                    >
                    </app-commission-wizard>
                </mat-card>
            </div>
            <div class="detail-card" *ngFor="let view of conf.left">
                <ng-container [ngTemplateOutlet]="GetTemplateByType(view.type)" [ngTemplateOutletContext]="{ view: view }"></ng-container>
            </div>
        </ng-container>
        <ng-container *appDetailViewRightContent>
            <div class="detail-card" *ngFor="let view of conf.right">
                <ng-container [ngTemplateOutlet]="GetTemplateByType(view.type)" [ngTemplateOutletContext]="{ view: view }"></ng-container>
            </div>
        </ng-container>
    </app-detail-view-template>
    <mat-card *ngIf="PreviewOpen" class="new-document-overlay">
        <button app-round-button class="back-button" (click)="PreviewedFileId$.next(null)">
            <fa-icon icon="chevron-right"></fa-icon>
        </button>
        <app-preview
            *ngIf="PreviewedFileId$ | async as id"
            [EmailEditorDialogData]="{ CommissionId: (Commission$ | async)?.Id }"
            [FileId$]="PreviewedFileId$"
            [fileExplorerContext]="{ directoryFileIds: ImageIds }"
            (ClosePreview)="PreviewedFileId$.next(null)"
            class="preview"
        ></app-preview>
    </mat-card>
</ng-container>
<ng-template #loadingTemplate>
    <app-loading></app-loading>
</ng-template>
<ng-template #entityHistoryTemplate let-view="view">
    <ng-container *ngIf="Commission$ | async as data">
        <app-entity-history class="card-height" [Expanded]="view.expanded" [EntityType]="EntityType.Commission" [EntityId]="data.Id"></app-entity-history>
    </ng-container>
</ng-template>

<ng-template #reportsTabGroupTemplate let-view="view">
    <ng-template #headerButtonTemplate>
        <app-add-report-button style="margin-right: -0.5rem" (click)="$event.stopPropagation()" [CustomerId]="(Commission$ | async)?.CustomerId" [CommissionId]="(Commission$ | async)?.Id" [Inverted]="false"></app-add-report-button>
    </ng-template>
    <ng-container [ngTemplateOutlet]="tabGroupTemplate" [ngTemplateOutletContext]="{ view, headerButtonTemplate }"> </ng-container>
</ng-template>
<ng-template #tabGroupTemplate let-view="view" let-headerButtonTemplate="headerButtonTemplate">
    <ng-container *ngIf="view.elements?.length > 0">
        <mat-expansion-panel class="custom-mat-expansion-panel" [expanded]="view.expanded" *ngIf="[] as countArray">
            <mat-expansion-panel-header [collapsedHeight]="HeaderHeight">
                <div class="card-header">
                    <fa-icon *ngIf="view.headlineIcon as icon" class="icon" [icon]="icon"></fa-icon>
                    <h3>
                        {{ view.headline }}<span *ngIf="countArray.length"> ({{ ArraySum(countArray) }})</span>
                    </h3>
                    <ng-container *ngIf="headerButtonTemplate" [ngTemplateOutlet]="headerButtonTemplate"></ng-container>
                </div>
            </mat-expansion-panel-header>
            <mat-tab-group>
                <mat-tab *ngFor="let childView of view.elements; index as index" [label]="getMatGroupTitle(childView.headline, countArray[index])" #tab>
                    <ng-container [ngTemplateOutlet]="GetTemplateByType(childView.type)" [ngTemplateOutletContext]="{ view: childView, index, countArray, tab }"></ng-container>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
    </ng-container>
</ng-template>
<ng-template #group let-view="view">
    <mat-expansion-panel class="custom-mat-expansion-panel" [expanded]="view.expanded">
        <mat-expansion-panel-header class="expansion-header"
            ><h3 matCardTitle *ngIf="view.headline">{{ view.headline }}</h3></mat-expansion-panel-header
        >
        <ng-container [ngTemplateOutlet]="GetTemplateByType(childView.type)" [ngTemplateOutletContext]="{ view: childView }" *ngFor="let childView of view.elements"> </ng-container>
    </mat-expansion-panel>
</ng-template>
<ng-template #commissionTitleTabGroupTemplate let-view="view">
    <ng-container *ngIf="Commission$ | async as data">
        <h1 *ngIf="(Commission$ | async)?.Deleted === true">VORSICHT, BITTE BEACHTEN! DIESES PROJEKT IST GELÖSCHT. JEGLICHE BEARBEITUNG DIESES PROJEKTES HAT KEINE AUSWIRKUNGEN! DIESE ANSICHT IST LEDIGLICH ZUR INFORMATION GEDACHT!</h1>
        <!-- farbliche Ecke an TabGroupCard: In MDQX umgesetzt über detail-list-template -->
        <mat-card class="commissionTitleTabGroupTemplate" *ngIf="!(showWizard$ | async)"
                  [class.commission-title-tab-card-corner-decoration]="(CommissionColor$ | async) !== null">
            <div *ngIf="CommissionColor$ | async as commissionColor"
                [class.commission-corner-color-decoration]="commissionColor !== null"
                [ngStyle]="{
                'background-color': commissionColor ? commissionColor : 'unset'
            }"></div>
            <header class="commissionTitleTabGroupTemplateHeader">
                <div class="title-text">
                    <div class="header-row">
                        <h3 *ngIf="data.Description">{{ data.Description }}</h3>
                        <h3 *ngIf="CommissionMainData | async as mainData">
                            <fa-icon [icon]="mainData.HeaderIcon"></fa-icon>
                            {{ mainData.Headline }}
                        </h3>
                        <h3 *ngIf="CommissionType$ | async as commissionType">
                            {{ commissionType.Name }}
                        </h3>
                        <span *ngIf="CommissionAddress$ | async as address">
                            <fa-icon icon="location-dot"></fa-icon>
                            <span class="link" (click)="OpenMapDialog(data)">
                                {{ address }}
                            </span>
                        </span>
                    </div>
                    <h3 *ngIf="!!(Customer$ | async)?.Name || data.CustomerName">
                        <fa-icon icon="building"></fa-icon>
                        {{ (Customer$ | async)?.Name || data.CustomerName }}
                    </h3>
                </div>
                <div class="flex flex-col gap-4 items-end">
                    <div class="flex gap-4 title-buttons">
                        <div class="akkord-button-wrapper" *ngIf="canGetAkkord$ | async">
                            <a app-button Lighter [matTooltip]="AkkordMeta.Breadcrumb" [routerLink]="['/', AkkordMeta.Path, data.Id]">
                                <fa-icon [icon]="AkkordMeta.Icon"></fa-icon>
                            </a>
                        </div>
                        <app-go-to-button *ngIf="showCustomerButtons && !!data.CustomerId && data.PartnerId === (Partner$ | async)?.Id" EntityType="customer" [matTooltip]="(customerLabel$ | async)" [EntityId]="data.CustomerId"></app-go-to-button>
                        <app-go-to-button *ngIf="data.ParentId" EntityType="commission" [matTooltip]="cls.getSingle$('Commission') | async" [EntityId]="data.ParentId"></app-go-to-button>
                        <app-go-to-button *ngIf="(PS.Has(PS.Permission.GetFiles) | async) && (FolderId$ | async) as id" EntityType="folder" matTooltip="DMS" [EntityId]="id"></app-go-to-button>
                        <div class="history-button-wrapper" *ngIf="showCustomerButtons && PS.Has(PS.Permission.GetEvents) | async">
                            <a *ngIf="!!data.CustomerId && data.PartnerId === (Partner$ | async)?.Id" app-button Lighter matTooltip="Chronik" [routerLink]="['/', ChronikPath, data.CustomerId]" [queryParams]="NavigateChronikFilter$ | async">
                                <fa-icon [icon]="ChronikIcon"></fa-icon>
                            </a>
                        </div>
                    </div>
                    <div *ngIf="(parentCommissionInfo$ | async) as parentCommissionInfo" class="parent-project">
                        <span class="link" [routerLink]="['/', CommissionMeta.Path, data.ParentId]"
                            ><fa-icon *ngIf="CommissionMeta.Icon as icon" class="icon" [icon]="icon" [matTooltip]="'Hauptprojekt'"></fa-icon>
                        {{ parentCommissionInfo }}</span>
                    </div>
                    <div class="flex gap-4">
                    <div *ngIf="department$ | async as department">{{cls.getSingle$('Department') | async}}: {{ department.Name }}</div>
                    <div *ngIf="partnerOfficeInfo$ | async as po">
                        <span *ngIf="po.count > 1">
                            Unternehmen: {{ po.partnerOffice?.Name }}
                        </span>
                    </div>
                </div>
                </div>
            </header>
            <!--            <mat-card-content>-->
            <mat-tab-group #commissionTitleTabGroupTemplateTabGroup *ngIf="view.elements?.length" preserveContent>
                <mat-tab id="{{ childView.type }}" *ngFor="let childView of view.elements" [label]="childView.headline" #tab>
                    <ng-template matTabContent>
                        <ng-container [ngTemplateOutlet]="GetTemplateByType(childView.type)" [ngTemplateOutletContext]="{ view: childView, tab: tab }"></ng-container>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </ng-container>
</ng-template>
<ng-template #detailListTemplateCommission let-view="view" let-tab="tab">
    <div style="max-width: 100vw" *ngIf="Commission$ | async as data">
        <app-detail-list-template [RequiredAdress]="CommissionLocationRequired | async" class="detail-card" [Editing]="Editing$ | async" [Data]="CommissionMainData | async"> </app-detail-list-template>
        <mat-expansion-panel class="custom-mat-expansion-panel detail-card" [expanded]="false">
            <mat-expansion-panel-header class="expansion-header"
                ><h2>{{ (cls.getLabels$('Commission') | async)?.wordBinding + 'daten' }}</h2></mat-expansion-panel-header
            >
            <mat-tab-group>
                <mat-tab [label]="(cls.getLabels$('Commission') | async)?.wordBinding + 'daten'">
                    <div class="flex flex-wrap">
                        <app-detail-list-template style="flex-basis: 20rem" class="grow" *ngFor="let d of CommissionSubData | async" [Data]="d" [Editing]="Editing$ | async" [Inline]="true"></app-detail-list-template>
                    </div>
                </mat-tab>
                <ng-container *ngIf="(Partner$ | async)?.PartnerSpecificationTypeId === PartnerSpecificationType.Appraiser">
                    <mat-tab label="Schadensort / -daten">
                        <app-detail-list-template [Data]="DamageFlowData$ | async" [Editing]="Editing$ | async"></app-detail-list-template>
                    </mat-tab>
                    <mat-tab label="Versicherungsdaten" *ngIf="!(IsVersicherung$ | async)">
                        <app-detail-list-template [Data]="VersicherungsData$ | async" [Editing]="Editing$ | async"></app-detail-list-template>
                    </mat-tab>
                </ng-container>
            </mat-tab-group>
        </mat-expansion-panel>
    </div>
</ng-template>
<ng-template #taskTemplate let-view="view">
    <ng-container *ngIf="Commission$ | async as data">
        <div class="taskboard-header">
            <fa-icon icon="clipboard-check" style="font-size: 1.5rem; padding-left: 1rem"></fa-icon>
            <span class="spacer"></span>
            <mat-form-field *ngIf="SearchBarActive">
                <input type="text" placeholder="Suche" [formControl]="SearchForm" matInput #input />
                <button class="clear-search" (click)="SearchForm.setValue('')" mat-icon-button *ngIf="SearchForm.value">
                    <fa-icon icon="times"></fa-icon>
                </button>
            </mat-form-field>
            <button class="ml-2" app-round-button [matTooltip]="SearchBarActive && !SearchForm.value ? 'Ausblenden' : 'Suche'" [attr.aria-label]=" SearchBarActive && !SearchForm.value ? 'Ausblenden' : 'Suche' " (click)="SearchButtonClicked()">
                <fa-icon [icon]="SearchBarActive && !SearchForm.value ? 'times' : 'search'"></fa-icon>
            </button>
            <button class="ml-2" app-round-button matTooltip="Filter" aria-label="Filter" (click)="filter.Open()" [matBadge]="TaskBoardFilterAmount$ | async" [matBadgeHidden]="!(TaskBoardFilterAmount$ | async)">
                <fa-icon icon="filter"></fa-icon>
            </button>
            <button class="ml-2" app-round-button matTooltip="Sortieren" aria-label="Sortieren" style="margin: 0.5rem" [matMenuTriggerFor]="sortMenu">
                <fa-icon icon="sort"></fa-icon>
            </button>
        </div>
        <mat-menu #sortMenu>
            <button mat-menu-item (click)="TaskBoardSort = { sortBy: 'endDate', direction: 'asc' }"><fa-icon icon="chevron-up"></fa-icon> Frist</button>
            <button mat-menu-item (click)="TaskBoardSort = { sortBy: 'endDate', direction: 'dsc' }"><fa-icon icon="chevron-down"></fa-icon> Frist</button>
            <button mat-menu-item (click)="TaskBoardSort = { sortBy: 'priority', direction: 'asc' }"><fa-icon icon="chevron-up"></fa-icon> Priorität</button>
            <button mat-menu-item (click)="TaskBoardSort = { sortBy: 'priority', direction: 'dsc' }"><fa-icon icon="chevron-down"></fa-icon> Priorität</button>
        </mat-menu>
        <mat-card>
            <app-tasks-board
                [inlineCompleteToggleButton]="true"
                [Search]="SearchForm.value"
                [Filter]="taskBoardFilter$ | async"
                [Sort]="TaskBoardSort"
                (FileClicked)="PreviewedFileId$.next($event); PreviewOpen = true"
                [NewTaskInitialValues]="{ CommissionId: data.Id }"
                [ShowNewButton]="canCreateTask$ | async"
            ></app-tasks-board>
            <app-filter-card #filter [Settings]="TaskBoardFilterSettings$ | async" [Values]="TaskBoardFilterValues$ | async" (ValuesChange)="TaskBoardFilterValues$.next($event)"></app-filter-card>
        </mat-card>
    </ng-container>
</ng-template>
<ng-template #shiftPlanTemplate let-view="view" let-tab="tab">
    <ng-container *ngIf="Commission$ | async as data">
        <mat-card style="max-height: 50vh" *ngIf="!tab || tab.isActive">
            <app-shift-plan
                #shiftPlanComponent
                [Headline]="false"
                (OnViewChange)="ShiftPlanActiveView$.next($event)"
                [View]="ShiftPlanActiveView$ | async"
                [AdditionalButtons]="AdditionalShiftPlanButtons"
                [AutoFilterCommissionByCurrentCommissionShifts]="false"
                [HeaderColorful]="false"
                [ShowResourcePlanButton]="false"
                [CommissionId]="data.Id"
            ></app-shift-plan>
        </mat-card>
    </ng-container>
</ng-template>
<ng-template #resourcePlanTemplate let-view="view" let-tab="tab">
    <ng-container *ngIf="Commission$ | async as data">
        <mat-card style="max-height: 50vh" *ngIf="!tab || tab.isActive">
            <app-resource-plan
                #resourcePlanComponent
                [ShowAddResourceButton]="(CommissionType$ | async)?.GeneratedEmployeeResourceSchedules?.length > 0"
                (AddResourceButtonClick)="onAddResourcesButtonClick()"
                (OnViewChange)="ResourcePlanActiveView$.next($event)"
                [View]="ResourcePlanActiveView$ | async"
                [AdditionalButtons]="AdditionalResourcePlanButtons"
                [HeaderColorful]="false"
                [ShowShiftplanButton]="false"
                style="max-height: 25rem; min-height: 25rem"
                [CommissionId]="data.Id"
            ></app-resource-plan>
        </mat-card>
    </ng-container>
</ng-template>
<ng-template #fileExplorerTemplate let-view="view">
    <app-file-explorer
        PreventFileClick
        PreventFileUploadClick
        (FilterOpen$)="ShownButtons = !$event"
        [SelectedFolderId]="(Folder$ | async)?.Id"
        [FileUploadButton]="true"
        (FileUploadClicked)="UploadFolderId = $event; PreviewOpen = false; OpenUploadDialog()"
        (FileClicked)="PreviewedFileId$.next($event); PreviewOpen = true"
        (fileExplorerContext)="ImageIds = $event.directoryFileIds"
        class="mat-card"
        style="padding: 0"
        [expanded]="view.expanded === false ? false : true"
    >
    </app-file-explorer>
</ng-template>
<ng-template #additionalFoldersFileExplorerTemplate let-view="view">
    <ng-container *ngFor="let additionalRootFolder of additionalRootFolders$ | async">
        <h3>{{ additionalRootFolder.Title }}</h3>
        <p *ngIf="!additionalRootFolder.hasRequiredToken">Sie sind nicht bei Sharepoint angemeldet. <a [routerLink]="['/', SettingsPageMeta.Path, SharepointSettingsMeta.Path]">Zu den Einstellungen</a></p>
        <app-file-explorer
            *ngIf="additionalRootFolder.hasRequiredToken"
            [DisableRoutingParams]="true"
            class="mat-card mt-2"
            style="padding: 0"
            [DisableBackButtonFolderId]="additionalRootFolder.Id"
            [sharepointRootFolder]="additionalRootFolder"
            [SelectedFolderId]="additionalRootFolder.Id"
            [additionalColumns]="[
                {name: 'ProjektNr', column: 'Projektnummer', size: '7rem'},
                {name: 'Status', column: 'Dokumentenstatus', size: '5rem'}
            ]"
            [hideColumns]="[
                'fileType',
                'createdAt',
                'size',
                'updatedAt',
            ]"
            [expanded]="view.expanded === false ? false : true"
        >
        </app-file-explorer>
    </ng-container>
</ng-template>
<ng-template #eventListTemplate let-view="view">
    <app-detail-commission-event-list *ngIf="!(Editing$ | async) && (PS.Has(PS.Permission.GetServiceHistory) | async)" [View]="view" [CommissionId]="(Commission$ | async)?.Id"></app-detail-commission-event-list>
</ng-template>
<ng-template #personListTemplate let-view="view">
    <app-involved-persons-list
        *ngIf="!(Editing$ | async) && !(IsGericht$ | async)"
        [entityId]="(Commission$ | async)?.Id"
        [entityType]="Person2EntityEntityTypeEnum.Commission"
        [expanded]="view.expanded"
        [complainTypeId]="beteiligtePersonenComplainTypeId$ | async"
        [canAdd]="!((Commission$ | async)?.Deleted || !(PS.Has$(PS.Permissions.EditCommission) | async))"
        headline="Projektbeteiligte"
        [headerIcon]="ContactBookMeta.Icon"
        addButtonText="Beteiligte Personen"
    ></app-involved-persons-list>
</ng-template>
<ng-template #bookingPositionListTemplate let-view="view">
    <app-booking-position-list-card
        *ngIf="PS.Has$(PS.Permissions.GetAccountsReceivableLedgers) | async"
        [Data]="BookingPositions$"
        (EntryClicked$)="BookingPositionClicked($event.entry, $event.element)"
        (NewClicked$)="NewBookingPositionClick$.next()"
        [Clickable]="true"
        [IsExpandable]="true"
        [Expanded]="view.expanded"
        [NewButton]="true"
        [HideColumns]="['InvoiceNumber']"
        style="max-height: 50vh"
    >
    </app-booking-position-list-card>
</ng-template>

<ng-template #ledgerImportListTemplate let-view="view" let-index="index" let-countArray="countArray">
    <ng-container *ngIf="PS.Has(PS.Permission.GetLedgerImports) | async">
        <app-ledger-import-list-card
            [NavigateOnClick]="true"
            [view]="view"
            *ngIf="LedgerImports$ | async as lis; else loadingTemplate"
            [LedgerImports]="lis"
            (NewLedgerImportClick)="onCreateLodgerImportClick($event)"
            (DocumentClick)="PreviewedFileId$.next($event); PreviewOpen = true"
            [ShowCreateTeilrechnung]="true"
            [DisableCreateTeilrechnung]="(offerLedgerImports$ | async | length) === 0"
            DisableCreateTeilrechnungHint="Für eine Teilrechnung muss zuerst ein {{LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.Offer)}}, ein {{LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.Measurement)}}  oder eine {{LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.OfferConfirmation)}} angelegt werden"
        ></app-ledger-import-list-card>
    </ng-container>
</ng-template>

<ng-template #auffaelligkeitListTemplate let-view="view" let-index="index" let-countArray="countArray">
    <app-interruption-events-list-card
        [canCreate]="canCreateInterruptionEvent$ | async"
        [Headline]="view.headline"
        [Expanded]="view.expanded"
        [IsExpandable]="true"
        [CommissionId]="(Commission$ | async)?.Id"
        [EventTypeId]="auffaelligkeitId$ | async"
        (Count)="countArray ? (countArray[index] = $event) : null"
    ></app-interruption-events-list-card>
</ng-template>

<ng-template #dokumentationListTemplate let-view="view" let-index="index" let-countArray="countArray">
    <app-interruption-events-list-card
        [canCreate]="canCreateInterruptionEvent$ | async"
        [Headline]="view.headline"
        [Expanded]="view.expanded"
        [IsExpandable]="true"
        [CommissionId]="(Commission$ | async)?.Id"
        [EventTypeId]="documentationId$ | async"
        (Count)="countArray ? (countArray[index] = $event) : null"
    ></app-interruption-events-list-card>
</ng-template>
<ng-template #regiearbeitenListTemplate let-view="view" let-index="index" let-countArray="countArray">
    <app-interruption-events-list-card
        [canCreate]="canCreateInterruptionEvent$ | async"
        [Headline]="view.headline"
        [Expanded]="view.expanded"
        [IsExpandable]="true"
        [CommissionId]="(Commission$ | async)?.Id"
        [EventTypeId]="regiearbeitId$ | async"
        (Count)="countArray ? (countArray[index] = $event) : null"
    ></app-interruption-events-list-card>
</ng-template>
<ng-template #nachnahmenListTemplate let-view="view" let-index="index" let-countArray="countArray">
    <app-interruption-events-list-card
        [canCreate]="canCreateInterruptionEvent$ | async"
        [Headline]="view.headline"
        [Expanded]="view.expanded"
        [IsExpandable]="true"
        [CommissionId]="(Commission$ | async)?.Id"
        [EventTypeId]="NachnahmenId$ | async"
        (Count)="countArray ? (countArray[index] = $event) : null"
    ></app-interruption-events-list-card>
</ng-template>
<ng-template #erschwernisListTemplate let-view="view" let-index="index" let-countArray="countArray">
    <app-interruption-events-list-card
        [canCreate]="canCreateInterruptionEvent$ | async"
        [Headline]="view.headline"
        [Expanded]="view.expanded"
        [IsExpandable]="true"
        [CommissionId]="(Commission$ | async)?.Id"
        [EventTypeId]="MangelId$ | async"
        (Count)="countArray ? (countArray[index] = $event) : null"
    ></app-interruption-events-list-card>
</ng-template>

<ng-template #mangelanzeigeListTemplate let-view="view" let-index="index" let-countArray="countArray">
    <app-interruption-events-list-card
        [canCreate]="canCreateInterruptionEvent$ | async"
        [Headline]="view.headline"
        [Expanded]="view.expanded"
        [IsExpandable]="true"
        [CommissionId]="(Commission$ | async)?.Id"
        [EventTypeId]="MangelanzeigenId$ | async"
        (Count)="countArray ? (countArray[index] = $event) : null"
    ></app-interruption-events-list-card>
</ng-template>

<ng-template #bedenkenanzeigeListTemplate let-view="view" let-index="index" let-countArray="countArray">
    <app-interruption-events-list-card
        [canCreate]="canCreateInterruptionEvent$ | async"
        [Headline]="view.headline"
        [Expanded]="view.expanded"
        [IsExpandable]="true"
        [CommissionId]="(Commission$ | async)?.Id"
        [EventTypeId]="BedenkenanzeigenId$ | async"
        (Count)="countArray ? (countArray[index] = $event) : null"
    ></app-interruption-events-list-card>
</ng-template>

<ng-template #hiddenBookingPositionListTemplate let-view="view" let-index="index" let-countArray="countArray">
    <app-dave-list-card
        (Count)="countArray ? (countArray[index] = $event) : null"
        Headline="Versteckte Abrechnungspositionen"
        *ngIf="(PS.Has(PS.Permission.GetAccountsReceivableLedgers) | async) && (HiddenBookingPositions$ | async)?.length > 0"
        [HeaderIcon]="BookingPositionMetaIcon"
        HeaderIcon2="slash"
        EmptyText="Keine versteckten Abrechnungspositionen vorhanden"
        [Data]="HiddenBookingPositions$"
        Hint="Diese Abrechnungspositionen wurden in Rechnungen, Abschlagsrechnungen und Schlussrechnungen in einer neuen Abrechnungspositionen zusammengefasst."
        [DisplayedCollums]="['BookingText', 'Information', 'CompleteCost', 'InvoiceNumber']"
        [TableHeaderCollumsMap]="{
            BookingText: 'Art-Nr.',
            Information: 'Bezeichnung',
            CompleteCost: 'Summe',
            Quantity: 'Menge',
            Unit: 'Einheit',
            InvoiceNumber: 'Re-Nr.'
        }"
        [IsExpandable]="true"
        [Expanded]="view.expanded"
        style="max-height: 50vh"
    >
    </app-dave-list-card>
</ng-template>
<ng-template #judgeListTemplate let-view="view">
    <app-involved-persons-list
        *ngIf="IsGericht$ | async"
        [entityId]="(Commission$ | async)?.Id"
        [entityType]="Person2EntityEntityTypeEnum.Commission"
        [expanded]="view.expanded"
        [complainTypeId]="judgePersonenComplainTypeId$ | async"
        [canAdd]="!((Commission$ | async)?.Deleted || !(PS.Has$(PS.Permissions.EditCommission) | async))"
        headline="Vorsitzenden"
        headerIcon="users"
        addButtonText="Vorsitzender"
    ></app-involved-persons-list>
</ng-template>
<ng-template #reportsListDiary let-view="view" let-index="index" let-countArray="countArray">
    <ng-container [ngTemplateOutlet]="reportsList" [ngTemplateOutletContext]="{ view: view, index: index, countArray: countArray, data: DiaryReports$, reportType: GeneratedDocumentsTypeSlugs.constructionDiary }"></ng-container>
</ng-template>
<ng-template #reportsListZusatz let-view="view" let-index="index" let-countArray="countArray">
    <ng-container [ngTemplateOutlet]="reportsList" [ngTemplateOutletContext]="{ view: view, index: index, countArray: countArray, data: ZusatzReports$, reportType: GeneratedDocumentsTypeSlugs.zusatzarbeit }"></ng-container>
</ng-template>
<ng-template #reportsListBedenken let-view="view" let-index="index" let-countArray="countArray">
    <ng-container [ngTemplateOutlet]="reportsList" [ngTemplateOutletContext]="{ view: view, index: index, countArray: countArray, data: BedenkenReports$, reportType: GeneratedDocumentsTypeSlugs.bedenken }"></ng-container>
</ng-template>
<ng-template #reportsListAuffaelligkeit let-view="view" let-index="index" let-countArray="countArray">
    <ng-container [ngTemplateOutlet]="reportsList" [ngTemplateOutletContext]="{ view: view, index: index, countArray: countArray, data: auffaelligkeitReports$, reportType: GeneratedDocumentsTypeSlugs.auffaelligkeit }"></ng-container>
</ng-template>
<ng-template #reportsListDokumentation let-view="view" let-index="index" let-countArray="countArray">
    <ng-container [ngTemplateOutlet]="reportsList" [ngTemplateOutletContext]="{ view: view, index: index, countArray: countArray, data: dokumentationReports$, reportType: GeneratedDocumentsTypeSlugs.dokumentation }"></ng-container>
</ng-template>
<ng-template #reportsListRegiearbeiten let-view="view" let-index="index" let-countArray="countArray">
    <ng-container [ngTemplateOutlet]="reportsList" [ngTemplateOutletContext]="{ view: view, index: index, countArray: countArray, data: regiearbeitReports$, reportType: GeneratedDocumentsTypeSlugs.regiearbeit }"></ng-container>
</ng-template>
<ng-template #reportsListMangel let-view="view" let-index="index" let-countArray="countArray">
    <ng-container [ngTemplateOutlet]="reportsList" [ngTemplateOutletContext]="{ view: view, index: index, countArray: countArray, data: MangelReports$, reportType: GeneratedDocumentsTypeSlugs.mangel }"></ng-container>
</ng-template>
<ng-template #reportsListErschwernis let-view="view" let-index="index" let-countArray="countArray">
    <ng-container [ngTemplateOutlet]="reportsList" [ngTemplateOutletContext]="{ view: view, index: index, countArray: countArray, data: erschwernisReports$, reportType: GeneratedDocumentsTypeSlugs.erschwernis }"></ng-container>
</ng-template>
<ng-template #reportsListOther let-view="view" let-index="index" let-countArray="countArray">
    <ng-container
        [ngTemplateOutlet]="reportsList"
        [ngTemplateOutletContext]="{
            view: view,
            index: index,
            countArray: countArray,
            data: OtherReports$,
            excludeReportTypes: [GeneratedDocumentsTypeSlugs.constructionDiary, GeneratedDocumentsTypeSlugs.zusatzarbeit, GeneratedDocumentsTypeSlugs.bedenken, GeneratedDocumentsTypeSlugs.mangel, GeneratedDocumentsTypeSlugs.erschwernis]
        }"
    ></ng-container>
</ng-template>
<ng-template #reportsList let-view="view" let-index="index" let-countArray="countArray" let-data="data" let-showIcon="showIcon" let-reportType="reportType" let-excludeReportTypes="excludeReportTypes">
    <app-dave-list-card
        (Count)="countArray ? (countArray[index] = $event) : null"
        [Headline]="view.headline"
        [HeaderIcon]="showIcon ? 'file-signature' : null"
        [EmptyText]="'Keine ' + view.headline + ' vorhanden'"
        [Data]="data"
        [HasSuffixButton]="true"
        [DisplayedCollums]="['label']"
        [Clickable]="true"
        [GetRouterLinkFunction]="GetRouteForGenDoc"
        [IsExpandable]="true"
        [Expanded]="view.expanded"
        style="max-height: 50vh"
    >
        <app-add-report-button [disabled]="(canCreateGeneratedDocument$ | async) === false" headerButton [PreselectedType]="reportType" [ExcludeTypes]="excludeReportTypes" [CustomerId]="(Commission$ | async)?.CustomerId" [CommissionId]="(Commission$ | async)?.Id"></app-add-report-button>
    </app-dave-list-card>
</ng-template>
<ng-template #klaegerListTemplate let-view="view">
    <app-involved-persons-list
        *ngIf="!(Editing$ | async) && (IsGericht$ | async)"
        [entityId]="(Commission$ | async)?.Id"
        [entityType]="Person2EntityEntityTypeEnum.Commission"
        [expanded]="view.expanded"
        [complainTypeId]="klagenderPersonenComplainTypeId$ | async"
        [canAdd]="!((Commission$ | async)?.Deleted || !(PS.Has$(PS.Permissions.EditCommission) | async))"
        headline="Partei: Kläger"
        headerIcon="users"
        addButtonText="Kläger"
    ></app-involved-persons-list>
</ng-template>
<ng-template #beklagteListTemplate let-view="view">
    <app-involved-persons-list
        *ngIf="!(Editing$ | async) && (IsGericht$ | async)"
        [entityId]="(Commission$ | async)?.Id"
        [entityType]="Person2EntityEntityTypeEnum.Commission"
        [expanded]="view.expanded"
        [complainTypeId]="beklagtePersonenComplainTypeId$ | async"
        [canAdd]="!((Commission$ | async)?.Deleted || !(PS.Has$(PS.Permissions.EditCommission) | async))"
        headline="Partei: Beklagte"
        headerIcon="users"
        addButtonText="Beklagte"
    ></app-involved-persons-list>
</ng-template>
<ng-template #selectedPartnerListTemplate let-view="view">
    <mat-expansion-panel class="custom-mat-expansion-panel" [expanded]="view.expanded" *ngIf="!(Editing$ | async) && (NetworkPartners$ | async).length > 1">
        <mat-expansion-panel-header [collapsedHeight]="HeaderHeight">
            <div class="card-header">
                <fa-icon class="icon" icon="user"></fa-icon>

                <h3>Wird bearbeitet von:</h3>

                <!-- ToDo 'a' statt 'button', wenn event.stopImmediatePropagation() tut -->
                <button
                    app-round-button
                    matTooltipPosition="left"
                    (click)="OpenPartnerSelect()"
                    [Disabled]="(Commission$ | async)?.Deleted || !(PS.Has$(PS.Permissions.EditCommission) | async) || !(PS.Has$(PS.Permissions.CanShareWithPartner) | async)"
                    matTooltip="Hinzufügen"
                >
                    <app-double-icon Icon="user" Icon2="plus"></app-double-icon>
                </button>
            </div>
        </mat-expansion-panel-header>
        <mat-card class="card">
            <!-- "clickable"-Klasse ist nur für den inset box shadow -->
            <ngx-simplebar class="clickable-list-container">
                <table mat-table [dataSource]="ShowSelectedPartners$ | async">
                    <ng-container matColumnDef="Name">
                        <td mat-cell *matCellDef="let rowData">
                            <label>{{ rowData.PartnerNo || 'No.' }} &nbsp; {{ rowData.Name || 'Platzhalter' }}</label>
                        </td>
                    </ng-container>
                    <tr mat-row *matRowDef="let rowData; columns: ['Name']" [routerLink]="['/', 'partner', rowData.Id]" routerLinkActive="active"></tr>
                </table>

                <table *ngIf="!((ShowSelectedPartners$ | async)?.length > 0)" style="width: 100%">
                    <tr>
                        <td class="empty-table-text">Kein Mitglied zugeordnet</td>
                    </tr>
                </table>
            </ngx-simplebar>
        </mat-card>
    </mat-expansion-panel>
</ng-template>
<ng-template #selectedUsersListTemplate let-view="view">
    <app-commission-user-list-card [canEdit]="(canEditCommissionUsers$ | async) && !(Commission$ | async).Deleted" *ngIf="!(Editing$ | async)" [commissionId]="(Commission$ | async).Id" [userToCommissionFromCommission]="userToCommissionFromCommission$ | async" [expanded]="view.expanded"></app-commission-user-list-card>
</ng-template>
<ng-template #commentsTemplate let-view="view">
    <app-comment-list
        *ngIf="Commission$ | async as commission"
        [CanDelete]="IamAssignee$ | async"
        [ViewConfig]="view"
        [EntityId]="commission.Id"
        [EntityType]="CommentEntityTypeEnum.Commission"
        [FileUploadParams]="CommentFileUploadParams$ | async"
    ></app-comment-list>
</ng-template>
<ng-template #processListTemplate let-view="view">
    <div style="position: relative">
        <app-dave-list-card
            [Headline]="'Prozesse'"
            [HeaderIcon]="ProcessMeta.Icon"
            [CustomCellTemplates]="{ ActiveStep: activeStep }"
            [EmptyText]="'Keine Prozesse vorhanden'"
            [Data]="ShowProcessList$ | async"
            [DisplayedCollums]="displayedColumnsProcessList"
            [TableHeaderCollumsMap]="TableConfigProcessList"
            [Clickable]="true"
            [IsExpandable]="true"
            [Expanded]="view.expanded"
            (EntryClicked$)="ProcessEntryClicked($event)"
        >
            <button headerButton app-round-button matTooltip="Filter" aria-label="Filter" (click)="processFilter.Open()" [matBadge]="ProcessFilterAmount$ | async" [matBadgeHidden]="!(ProcessFilterAmount$ | async)">
                <fa-icon icon="filter"></fa-icon>
            </button>
        </app-dave-list-card>
        <app-filter-card #processFilter [Settings]="ProcessFilterSettings" [Values]="ProcessFilterValues$ | async" (ValuesChange)="ProcessFilterValues$.next($event)"></app-filter-card>
    </div>
</ng-template>
<ng-template #activeStep let-data="data">
    <div *ngIf="data.ActiveStep || data.ActiveStep === 0" [matBadge]="data.ActiveStep + 1" matBadgePosition="center" matBadgeSize="medium" matBadgeColor="primary" class="theme-override task-theme process-step-bar-wrapper">
        <div class="process-step-bar app-background-primary"></div>
    </div>
</ng-template>

<ng-template #commissionOverviewTemplate let-view="view">
    <mat-card>
        <app-commission-overview [entityRoles]="CommissionEntityRoles$ | async" *ngIf="Commission$ | async as commission" [DeleteMileStonePermission]="DeleteMileStones$ | async" [CreateMileStonePermission]="CreateMileStones$ | async" [EditMileStonePermission]="EditMileStone$ | async" [GetMileStonePermission]="canGetMilestones$ | async" [CommissionId]="commission.Id"></app-commission-overview>
    </mat-card>
</ng-template>

<ng-template #resourceListTemplate let-view="view">
    <app-resource-to-commission-popup [CommissionId]="(Commission$ | async)?.Id" [Expanded]="view.expanded" [Expandable]="true"></app-resource-to-commission-popup>
</ng-template>

<ng-template #resourceScheduleListeTemplate let-view="view">
    <app-resource-schedule-list-card [CommissionId]="(Commission$ | async)?.Id" [Expanded]="view.expanded" [Expandable]="true"></app-resource-schedule-list-card>
</ng-template>

<ng-template #materialListTemplate let-view="view">
    <app-material-list [CommissionId]="(Commission$ | async)?.Id" [Expanded]="view.expanded" [Expandable]="true"></app-material-list>
</ng-template>

<ng-template #groupListTemplate let-view="view">
    <app-group-list [CommissionId]="(Commission$ | async)?.Id" [Expanded]="view.expanded" [Headline]="view.headline" (SendEmailClick)="OpenMailDialog($event.group, $event.toType)"></app-group-list>
</ng-template>
<mat-menu #menu="matMenu">
    <ng-container *ngIf="childCommissionColumnSettings$ | async as optionalColumns">
        <button mat-menu-item (click)="updateChildCommissionColumn('Department'); $event.stopPropagation()">
            {{ optionalColumns.includes('Department') ?  ((departmentLabel$ | async) || 'Abteilung') + ' ausblenden' : ((departmentLabel$ | async) || 'Abteilung') + ' anzeigen' }}
        </button>
        <button mat-menu-item (click)="updateChildCommissionColumn('PartnerOffice'); $event.stopPropagation()">
            {{ optionalColumns.includes('PartnerOffice') ? 'Unternehmen ausblenden' : 'Unternehmen anzeigen' }}
        </button>
        <button mat-menu-item (click)="updateChildCommissionColumn('InterneNummer'); $event.stopPropagation()">
            {{ optionalColumns.includes('InterneNummer') ? 'Interne Nr. ausblenden' : 'Interne Nr. anzeigen' }}
        </button>
        <button mat-menu-item (click)="updateChildCommissionColumn('createdAt'); $event.stopPropagation()">
            {{ optionalColumns.includes('createdAt') ? 'Erstelldatum ausblenden' : 'Erstelldatum anzeigen' }}
        </button>
    </ng-container>
</mat-menu>
<ng-template #childCommissionsTemplate let-view="view" let-index="index" let-countArray="countArray">
    <app-dave-list-card
        (Count)="countArray ? (countArray[index] = $event) : null"
        [Headline]="(isTsb$ | async) ? (cls.getMultiple$('Commission') | async) : view.headline || 'Teilprojekte'"
        [HeaderIcon]="CommissionMeta.Icon"
        [EmptyText]="'Keine ' + ((isTsb$ | async) ? (cls.getMultiple$('Commission') | async) : view.headline || 'Teilprojekte') + ' vorhanden'"
        [Data]="ChildCommissions$ | async"
        [DisplayedCollums]="childCommissionColumns$ | async"
        [TableHeaderCollumsMap]="{ Auftragsnummer: 'Auftragsnummer', Description: 'Bezeichnung', InterneNummer: cls.getSingle$('CommissionInternalNumberShort') | async, createdAt: 'Erstelldatum', status: 'Status', Department: ((departmentLabel$ | async) || 'Abteilung'), PartnerOffice: 'Unternehmen' }"
        [Clickable]="true"
        [GetRouterLinkFunction]="GetRouteForCommissionImport"
        [IsExpandable]="true"
        [Expanded]="view.expanded"
        (ExpandedChange)="childCommissionExpanded = $event"
        style="max-height: 50vh"
    >
        <button *ngIf="!SearchBarActive && childCommissionExpanded && (ChildCommissionsCount$ | async)" headerButton app-round-button matTooltip="Zus. Spalten anzeigen" [matMenuTriggerFor]="menu">
            <fa-icon icon="table-columns"></fa-icon>
        </button>
        <button headerButton app-round-button [matTooltip]="(cls.getSingle$('Commission') | async) + ' zuordnen'" (click)="addChildCommissionClick()">
            <app-double-icon [Icon]="CommissionMeta.Icon" Icon2="plus"></app-double-icon>
        </button>
    </app-dave-list-card>
</ng-template>
<ng-template #CommissionBusinessVolumeList let-view="view" let-index="index" let-countArray="countArray">
    <app-commission-busines-volume-list
        *ngIf="PS.Has$(PS.Permissions.GetBusinessVolume) | async"
        style="max-height: 50vh"
        [Expandable]="true"
        [Expanded]="view.expanded"
        [CommissionId]="(Commission$ | async)?.Id"
        [Columns]="['customerName', 'businessVolumeNo', 'amount', 'createdAt']"
        [tableLayoutFixed]="true"
    >
    </app-commission-busines-volume-list>
</ng-template>
<ng-template #personListEntry let-data="data">
    <app-person-list-entry [Person]="data"></app-person-list-entry>
</ng-template>
<ng-template #blueprintTemplate let-view="view">
    <app-blueprint [expanded]="view.expanded" [CommissionId]="(Commission$ | async)?.Id" (EventMarkerClicked)="OpenEditEventDialog($event)" (EventListEntryClicked)="OpenEditEventDialog($event)"></app-blueprint>
</ng-template>

<ng-template #departmentSelectTemplate>
    <div class="flex gap-2">
        <mat-form-field class="grow">
            <mat-label>{{cls.getSingle$('ExecutingDepartment') | async}}</mat-label>
            <app-select-search
                [formControl]="CommissionForm.controls.DepartmentId"
                [Options]="departments$ | async"
                [OptionTemplate]="departmentSelectOptionTemplate"
                [CompareOptions]="CompareById"
                [required]="DepartmentRequired | async"
            ></app-select-search>
        </mat-form-field>
        <button app-round-button (click)="NewDepartmentClick()" [matTooltip]="'Neue ' + (cls.getSingle$('Department') | async) + ' anlegen'" type="button">
            <fa-icon icon="plus"></fa-icon>
        </button>
    </div>
</ng-template>
<ng-template #departmentSelectOptionTemplate let-option>
    <app-department-option [departmentEntity]="option"></app-department-option>
</ng-template>
